import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import { setModoTela, initForm } from './unidadeActions';

class UnidadeForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='id_cidade'
								component={Select}
								options={this.props.listaCidade}
								label='Cidade'
								cols='12 12 12 12'
								placeholder='Selecionea cidade'
								readOnly={readOnly} />
								
							<Field
								name='latitude'
								component={LabelAndInput}
								label='Latitude' placeholder='Informe a latitude'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								name='longitude'
								component={LabelAndInput}
								label='Longitude' placeholder='Informe a longitude'
								cols='12 6 4 3'
								readOnly={readOnly} />
								
							<Field
								name='custo_operacao'
								component={LabelAndInputNumber}
								label='Custo da Operação' placeholder='Informe o custo'
								cols='12 12 12 12'
								casas={4}
								readOnly={readOnly} />
								
							<Field
								name='logistica_direta'
								component={LabelAndCheckbox}
								label='Logística Direta' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
								
							<Field
								name='estoque_minimo_s10'
								component={LabelAndInputNumber}
								label='Estoque Mínimo S10' placeholder='Informe a quantidade'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />
							
							<Field
								name='estoque_minimo_s500'
								component={LabelAndInputNumber}
								label='Estoque Mínimo S500' placeholder='Informe a quantidade'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='vazao_bomba_carga_s10'
								component={LabelAndInputNumber}
								label='Vazão Carga de S10 (L/min)' placeholder='Informe'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />
							
							<Field
								name='vazao_bomba_descarga_s10'
								component={LabelAndInputNumber}
								label='Vazão Descarga de S10 (L/min)' placeholder='Informe'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />
						</Row>
						<Row>							
							<Field
								name='vazao_bomba_carga_s500'
								component={LabelAndInputNumber}
								label='Vazão Carga de S500 (L/min)' placeholder='Informe'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />
							
							<Field
								name='vazao_bomba_descarga_s500'
								component={LabelAndInputNumber}
								label='Vazão Descarga de S500 (L/min)' placeholder='Informe'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='tempo_boca'
								component={LabelAndInputNumber}
								label='Tempo do Processo por Boca Mínimo S500 (min)' placeholder='Informe'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

UnidadeForm = reduxForm({form: 'unidadeForm', destroyOnUnmount: false})(UnidadeForm);
const mapStateToProps = state => ({
	sessao: state.auth.unidade,
	formularioValues: getFormValues('unidadeForm')(state),
	registro: state.unidade.registro,
	listaCidade: state.unidade.listaCidade
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeForm);
